import { shortTicker } from "~utils";

export function getTwoPartTicker(securityName: string, tickerId: string) {
  const [firstName, secondName] = securityName.split("/");
  const ticker = shortTicker(tickerId).toUpperCase();
  const firstTicker = ticker.slice(0, 3);
  const secondTicker = ticker.slice(3, 7);

  const isTwoPartTicker = Boolean(
    firstName && secondName && ticker.length === 6
  );

  return {
    isTwoPartTicker,
    firstName,
    firstTicker,
    secondName,
    secondTicker,
  };
}
